import styled from "styled-components";

const Background = styled.div`
    && {
        min-height: 100vh;
        background-image: url("lowpoly.png");
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
        background-color: var(--color-bg-dark);
    }
`;

export default Background;